module.exports = __webpack_public_path__ + "static/media/dien-toan.a29a59f1.png";